export default "__VITE_ASSET__C4EA6mjt__"